import dayjs from './day-js-config';
import { DEFAULT_LOCALE, DEFAULT_INPUT_FORMAT, LOCALE_MAPPINGS } from './constants';
export function formatDate(date, outputFormat, inputFormat, locale) {
    const currentDate = dayjs(date);
    if (!dayjs(date, inputFormat || DEFAULT_INPUT_FORMAT, true).isValid())
        throw new Error(`Invalid input format value '${inputFormat}' when trying to format '${date}'`);
    if (!currentDate.isValid())
        throw new Error(`Invalid date format: ${date}`);
    if (!outputFormat)
        throw new Error('Output format is missing, output format required');
    return currentDate.locale(LOCALE_MAPPINGS[locale || DEFAULT_LOCALE]).format(outputFormat);
}
